/** キーの割り当て（docs/06_ui-ux.md 3 章）。変更機能とゲームパッド対応に備えてここに集める */
export type Action =
  | 'editRoute'
  | 'confirm'
  | 'cancel'
  | 'undo'
  | 'clearRoute'
  | 'focusPlayer'
  | 'fly'
  | 'toggleStyle'
  | 'toggleForecastLayer'
  | 'toggleView'
  | 'cameraPreset'
  | 'watchPrev'
  | 'watchNext'
  | 'fastForward1'
  | 'fastForward2'
  | 'fastForward4';

export const KEYMAP: Record<Action, string[]> = {
  editRoute: ['KeyR'],
  confirm: ['Enter', 'NumpadEnter'],
  cancel: ['Escape'],
  undo: ['Backspace'],
  clearRoute: ['Delete'],
  focusPlayer: ['KeyC'],
  fly: ['KeyF'],
  toggleStyle: ['KeyQ'],
  toggleForecastLayer: ['KeyL'],
  toggleView: ['KeyM'],
  cameraPreset: ['KeyZ'],
  watchPrev: ['BracketLeft'],
  watchNext: ['BracketRight'],
  fastForward1: ['Digit1'],
  fastForward2: ['Digit2'],
  fastForward4: ['Digit3'],
};
